import './about.css';
import image1 from '../images/young-black-doctor.jpg';
import image2 from '../images/mentor.jpg';
import image3 from '../images/hijabdoc.jpg';
import scholars from '../images/schola.jpg'
import advocacy from '../images/adv.jpeg'
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import BackToTopButton from '../components/backtotop';

function About() {
    const scrollToBottom = () => {
        window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
    };
    const approach_data = [
        {
            title: "Scholarships",
            img: scholars,
            description: "Providing financial support to outstanding minority students who demonstrate academic excellence, leadership, and commitment."
        },
        {
            title: "Mentorship",
            img: image2,
            description: "Connecting scholars with experienced medical professionals for guidance and support throughout their medical education."
        },
        {
            title: "Advocacy",
            img: advocacy,
            description: "Promoting greater minority representation in medicine and raising awareness of the challenges these students face."
        },
    ]

    const settings = {
        dots: true,
        infinite: true,
        speed:500,
        slidesToShow:1,
        slidesToScroll:1,
        arrows: true
    };
    return(
        <div className = 'about-container'>
            <section className='top-container'>
                <h1>About Us</h1>
                <p>FAAMS is a nonprofit organization dedicated to supporting African-American medical students through scholarships and mentorship.<br/> 
                    Our mission is to empower the next generation of physicians and promote diversity in medicine.</p>
                <div className='scroll-down' onClick={scrollToBottom}></div>
            </section>
            <section className = 'section1'>
                <div className = 'text-content'>
                <h2>Our Values</h2>
                <p>We envision a world where every medical student, regardless of background, has the opportunity to succeed. 
                    By equipping African-American students with essential resources, we foster a more diverse and inclusive medical field. 
                    Our goal is to empower future physicians to lead, advocate for underserved communities, and challenge systemic
                     barriers in medical education and healthcare.</p>
                </div>
                <img src={image1} alt="our-values-image"/>
            </section>
            <section className = 'section2'>
                <h2>Our Approach</h2>
                <div className='approach'>
                    <Slider {...settings}>
                    {approach_data.map((a) => (
                        <div className='approach-cards'>
                            <div className='top-approach-card'>
                                <img src={a.img}/>
                            </div>
                            <div className ='bottom-approach-card'>
                                <h3>{a.title}</h3>
                                <p>{a.description}</p>
                            </div>
                        </div>
                    )
                )}
                </Slider>
                </div>
            </section>
            <section className = 'section3'>
            <div className = 'text-content'>
            <h2>The Future Starts With <strong>YOU</strong></h2>
                <p>We are laying the foundation to support African-American medical students through scholarships and mentorship. 
                    With your help through donations, partnerships, and advocacy, we can make this vision a reality. 
                    Every contribution brings us closer to a more inclusive and representative medical field.</p>
            </div>
            <img src={image3} alt="future-image" />
            </section>
            <BackToTopButton />
        </div>
    )



}
export default About;